import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Button } from '../../components/ui/button';
import { FolderOpen, Users, FileText } from 'lucide-react';

export const UnterweisungenLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      key: 'kategorien',
      label: 'Kategorien',
      icon: FolderOpen,
      path: '/admin/unterweisungen/kategorien'
    },
    {
      key: 'mitarbeiter',
      label: 'Mitarbeiter',
      icon: Users,
      path: '/admin/unterweisungen/mitarbeiter'
    },
    {
      key: 'unterweisungen',
      label: 'Unterweisungen',
      icon: FileText,
      path: '/admin/unterweisungen/erstellen'
    }
  ];

  const activeTab = location.pathname.includes('mitarbeiter') 
    ? 'mitarbeiter' 
    : location.pathname.includes('erstellen')
    ? 'unterweisungen'
    : 'kategorien';

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header with Tabs */}
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">Unterweisungen</h1>
          
          {/* Tabs */}
          <div className="border-b border-gray-200 dark:border-gray-700">
            <nav className="flex space-x-4 sm:space-x-8" aria-label="Tabs">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    onClick={() => navigate(tab.path)}
                    className={`
                      flex items-center gap-2 py-3 px-1 border-b-2 text-sm font-medium transition-colors
                      ${isActive 
                        ? 'border-blue-600 text-blue-600' 
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }
                    `}
                  >
                    <Icon className="h-4 w-4" />
                    <span className="hidden sm:inline">{tab.label}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Content */}
        {children}
      </div>
    </DashboardLayout>
  );
};
